import React from 'react';
import { List, Card, Spin, Button, Typography } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, UnorderedListOutlined } from '@ant-design/icons';
import moment from 'moment';
import type { OrderDetails } from '../../types';

const { Text } = Typography;

interface StudyQueueProps {
  orders: OrderDetails[];
  selectedIndex: number;
  collapsed: boolean;
  loading: boolean;
  onSelect: (order: OrderDetails, index: number) => void;
  onToggleCollapse: () => void;
}

const StudyQueue: React.FC<StudyQueueProps> = ({
  orders,
  selectedIndex,
  collapsed,
  loading,
  onSelect,
  onToggleCollapse,
}) => (
  <>
    <div className="sider-header">
      <h4 className="sider-title">
        {!collapsed && (
          <>
            <UnorderedListOutlined className="sider-title-icon" />
            <span>Selected Studies</span>
          </>
        )}
      </h4>
      <Button type="text" icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} onClick={onToggleCollapse} />
    </div>
    <div className="sider-content">
      <Spin spinning={loading}>
        {!collapsed && (
          <List
            dataSource={orders}
            renderItem={(order, idx) => (
              <List.Item
                onClick={() => onSelect(order, idx)}
                className={`study-list-item ${selectedIndex === idx ? 'study-list-item-selected' : 'study-list-item-default'}`}
              >
                <Card
                  className={`study-card ${selectedIndex === idx ? 'study-card-selected' : 'study-card-default'}`}
                  bordered={false}
                  hoverable
                >
                  <div className="patient-name-text">{order.pacs_order?.patient?.pat_name}</div>
                  <div className="study-details-text" title={`${order.pacs_order?.po_modality} | ${order.pacs_order?.po_diag_desc}`}>
                    {order.pacs_order?.po_modality} | {order.pacs_order?.po_diag_desc}
                  </div>
                  <div className="study-date-text">
                    {moment(order.pacs_order?.po_req_time).format('DD/MM/YYYY hh:mmA')}
                  </div>
                </Card>
              </List.Item>
            )}
          />
        )}
      </Spin>
    </div>
  </>
);

export default StudyQueue;
